import { configureStore } from '@reduxjs/toolkit';

import { app } from './app/appSlice';
import { account } from './account/accountSlice';
import { dispatcher } from './dispatcher/dispatcherSlice';
import { eai } from './eai/eaiSlice';
import { reporting } from './reporting/reportingSlice';
import { system } from 'features/system/systemSlice';

// ==============================|| REDUCER ||============================== //

export const store = configureStore({
  reducer: {
    app,
    account,
    dispatcher,
    eai,
    reporting,
    system
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false
    })
});

export default store;
